import { cn } from "@/lib/utils";

const FILES = { full: "logo", wordmark: "wordmark", symbol: "simbolo" };

export const Logo = ({ variant = "wordmark", className, testId = "brand-logo" }) => {
  const base = FILES[variant];
  return (
    <span className="inline-flex" data-testid={testId}>
      <img src={`/brand/${base}-viola.png`} alt="USocial Agency" className={cn("dark:hidden", className)} />
      <img src={`/brand/${base}-bianco.png`} alt="USocial Agency" className={cn("hidden dark:inline", className)} />
    </span>
  );
};
